import { List } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'

import * as actions from './actions'
// @ts-ignore
import { DifferentActivities, DifferentActivity, Loaded } from 'store/records/differentActivities'

import { IDifferentActivitiesRecord, IDifferentActivity } from './interface'

const handleActivitiesRequest = (state: IDifferentActivitiesRecord) => state.set('pending', true)

const handleGetPreviousActivitiesSuccess = (state: IDifferentActivitiesRecord, { payload: { data = [] } }) =>
  state
    .set(
      'previous',
      List(
        data.map(
          (previousActivity: IDifferentActivity) =>
            new DifferentActivity({
              ...previousActivity,
              activityId: previousActivity && previousActivity.id,
            })
        )
      )
    )
    .set('pending', false)
    .setIn(['loaded', 'previous'], true)

const handleGetPreviousActivitiesFail = (state: IDifferentActivitiesRecord) =>
  state.set('previous', List()).set('pending', false).setIn(['loaded', 'previous'], false)

const handleGetUpcomingActivitiesSuccess = (state: IDifferentActivitiesRecord, { payload: { data = [] } }) =>
  state
    .set(
      'upcoming',
      List(
        data.map(
          (upcomingActivity: IDifferentActivity) =>
            new DifferentActivity({
              ...upcomingActivity,
              activityId: upcomingActivity && upcomingActivity.id,
            })
        )
      )
    )
    .set('pending', false)
    .setIn(['loaded', 'upcoming'], true)

const handleGetUpcomingActivitiesFail = (state: IDifferentActivitiesRecord) =>
  state.set('upcoming', List()).set('pending', false).setIn(['loaded', 'upcoming'], false)

const handleSetActivitiesLoadStatusToDefault = (state: IDifferentActivitiesRecord) => state.set('loaded', new Loaded())

const handlePendingAfterRedirect = (state: IDifferentActivitiesRecord) => state.set('pending', false)

export default handleActions(
  {
    [actions.getPreviousActivities.success as any]: handleGetPreviousActivitiesSuccess,
    [actions.getUpcomingActivities.success as any]: handleGetUpcomingActivitiesSuccess,
    [actions.getPreviousActivities.fail as any]: handleGetPreviousActivitiesFail,
    [actions.getUpcomingActivities.fail as any]: handleGetUpcomingActivitiesFail,
    [actions.setActivitiesLoadStatusToDefault as any]: handleSetActivitiesLoadStatusToDefault,
    [actions.setFalsePendingStatus as any]: handlePendingAfterRedirect,
    [combineActions(actions.getPreviousActivities, actions.getUpcomingActivities, actions.tryDifferentActivity) as any]:
      handleActivitiesRequest,
  },
  new DifferentActivities()
)
